import React, { useEffect, useRef } from 'react'
import './Header.scss';

const Header = () => {


    const menu = useRef();
    const close = useRef();
    const search = useRef();
    const colorPalette = useRef();
    const toggleTheme = useRef();
    

    const clickColorBox = (color) => {
        document.documentElement.style.setProperty('--mainColor', '#' + color);
        colorPalette.current.classList.remove('userClick');
    }

    const toggleMenu = () => {
        menu.current.classList.toggle('userClick');
        close.current.classList.toggle('fa-times');

        search.current.classList.remove('userClick');
        colorPalette.current.classList.remove('userClick');
    }

    const toggleSearch = () => {
        search.current.classList.toggle('userClick');

        menu.current.classList.remove('userClick');
        close.current.classList.remove('fa-times');
        colorPalette.current.classList.remove('userClick');
    }

    const toggleColorBox = () => {
        colorPalette.current.classList.toggle('userClick');

        menu.current.classList.remove('userClick');
        close.current.classList.remove('fa-times');
        search.current.classList.remove('userClick');
    }

    const toggleThemeColor = () => {
        toggleTheme.current.classList.toggle('fa-sun');
        document.body.classList.toggle('userClick');
    }


    useEffect(() => {
        window.onscroll = () => {
            menu.current.classList.remove('userClick');
            close.current.classList.remove('fa-times');
            search.current.classList.remove('userClick');
            colorPalette.current.classList.remove('userClick');
        }
    }, []);

    return (
        <header className="header">

            <a href="#home" className="logo">logo</a>

            <div className="icons">
                <div className="fas fa-moon" onClick={toggleThemeColor}  ref={toggleTheme}></div>
                <div className="fas fa-palette" onClick={toggleColorBox}></div>
                <div className="fas fa-search" onClick={toggleSearch}></div>
                <div className="fas fa-bars" onClick={toggleMenu} ref={close}></div>
            </div>

            <nav className="navbar" ref={menu}>
                <a href="/#home">home</a>
                <a href="/#services">services</a>
                <a href="/#gallery">gallery</a>
                <a href="/#pricing">pricing</a>
                <a href="/#review">review</a>
                <a href="/#contact">contact</a>
            </nav>

            <form action="" className="search-form" ref={search}>
                <input type="search" placeholder="search here..." id="searchBox" />
                <label htmlFor="searchBox" className="fas fa-search"></label>
            </form>


            <div className="color-palette" ref={colorPalette}>
                <h3>chose color</h3>
                <div className="colors">
                    {
                        [
                            '2980b9',
                            '27ae60',
                            'e74c3c',
                            '8e44ad',
                            'b33771',
                            '0fd9b1',
                            'ff9f1a',
                            'e84393',
                            '17c0eb',
                        ].map(color => (
                            <div
                                key={color}
                                className="color"
                                style={{ backgroundColor: `#${color}` }}
                                onClick={() => clickColorBox(color)}></div>
                        ))
                    }
                </div>
            </div>
        </header>
    );
}

export default Header